import { render, staticRenderFns } from "./saleinvoice.vue?vue&type=template&id=1d7e8b5a&"
import script from "./saleinvoice.vue?vue&type=script&lang=ts&"
export * from "./saleinvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports